import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-right"
      closeButton
      richColors
      className="toaster group z-[9999]"
      toastOptions={{
        duration: 4500,
        classNames: {
          toast:
            // Opaque, high-contrast container
            "group toast group-[.toaster]:bg-raisin_black-400 group-[.toaster]:text-white group-[.toaster]:border-raisin_black-600 group-[.toaster]:shadow-xl group-[.toaster]:rounded-lg",
          description:
            // Softer description color for readability on dark
            "group-[.toast]:text-zinc-300",
          actionButton:
            "group-[.toast]:bg-steel_blue-500 group-[.toast]:text-cool_gray-900 group-[.toast]:hover:bg-steel_blue-400",
          cancelButton:
            "group-[.toast]:bg-english_violet-500 group-[.toast]:text-cool_gray-900 group-[.toast]:hover:bg-english_violet-400",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
